import { useEffect, useState } from 'react';

export const useMediaQuery = (query: string, fallbackMatches = false) => {
  const getMatches = () => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return fallbackMatches;
    }
    return window.matchMedia(query).matches;
  };

  const [matches, setMatches] = useState(getMatches);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      setMatches(fallbackMatches);
      return undefined;
    }

    const mediaQuery = window.matchMedia(query);
    const handleChange = () => setMatches(mediaQuery.matches);
    handleChange();

    mediaQuery.addEventListener?.('change', handleChange);
    return () => {
      mediaQuery.removeEventListener?.('change', handleChange);
    };
  }, [fallbackMatches, query]);

  return matches;
};
